/* ═══════════════════════════════════════════════════════════════════════════
   GRAVV RACE BOOKS — Static curated catalogue
═══════════════════════════════════════════════════════════════════════════ */

export const CATALOGUE = [
  {
    id: "utmb",
    numero: "01",
    nom: "UTMB",
    sousTitre: "La référence mondiale, le tour du Mont-Blanc en autonomie partielle.",
    tagline: "Le tour du toit de l'Europe — vingt-quatre heures dans l'air des cimes.",
    region: "Haute-Savoie · Alpes",
    lieu: "Chamonix",
    date: "29 août",
    dateISO: "2026-08-29",
    distance: 171,
    dplus: 10000,
    dminus: 10000,
    cutoff: "46:30",
    itra: 6,
    plateau: 2300,
    finishRate: 64,
    ravitos: 12,
    version: "V4",
    edition: "2026",
    tags: ["Ultra", "100 Milles", "Alpes", "Automne"],
    cardColor: "#C49A3C",
    cardTextColor: "#FFFFFF",
    record: { time: "19:49:30", holder: "Kilian Jornet", year: 2022 },
    profile: [[0,1035],[10,1900],[20,2500],[28,2600],[35,1900],[45,2100],[55,2600],[65,2000],[75,1800],[85,2300],[95,2100],[105,1850],[115,2200],[125,2600],[135,1900],[145,2000],[155,1700],[165,1900],[171,1035]],
    overview: "171 km, 10 000 m D+. Le tour du Mont-Blanc en autonomie partielle. Départ Chamonix vendredi soir, retour Chamonix dimanche matin. 12 ravitos, cutoffs stricts.",
    segments: [
      { label: "Chamonix → Saint-Gervais", distKm: 22, dplus: 900, dminus: 300, note: "Départ nocturne. Partir lentement — maximum 10 km/h sur le plat. 60% des abandons partent trop vite.", isCritical: false },
      { label: "Saint-Gervais → Courmayeur", distKm: 51, dplus: 3200, dminus: 3100, note: "Col du Mont-Bonhomme (2329m), Grand Col Ferret (2537m). La montée clé.", isCritical: true },
      { label: "Courmayeur → Champex-Lac", distKm: 42, dplus: 2400, dminus: 2400, note: "Grand Raid. Ravito Courmayeur : max 12 min. Si tu t'assieds trop longtemps, le corps refroidit et tu ne repars pas.", isCritical: true },
      { label: "Champex-Lac → Chamonix", distKm: 56, dplus: 3500, dminus: 4200, note: "Tête aux Vents (km 163) : 600 m de montée pure, jambes mortes. Compter en pas, pas en km.", isCritical: true },
    ],
    insights: [
      { numero: "01", titre: "Partir lentement", texte: "La première montée vient à 8 km. Maximum 10 km/h sur le plat initial. Le départ massif fait monter trop vite — 60% des abandons partent trop vite.", votes: 5, badge: "TIP" },
      { numero: "02", titre: "Courmayeur : 12 min max", texte: "Crew autorisé, repas chaud, change. Si tu t'assieds plus de 12 minutes, le corps refroidit et tu ne repars pas. Demi-portion + bouillon.", votes: 4, badge: "TIP" },
      { numero: "03", titre: "Grand Col Ferret · seconde couche", texte: "À 2 537 m entre 2 h et 5 h. Vent traversier, sensation -8 °C une année sur deux. Couche synthétique impérative — pas de coton.", votes: 6, badge: "WARNING" },
      { numero: "04", titre: "Tête aux Vents · 600 m d'un coup", texte: "Dernière montée km 163. Marche pure, jambes mortes. Compter 90 min. Ne pas regarder la montre, compter en pas.", votes: 3, badge: "TIP" },
    ],
    contributions: [],
  },
  {
    id: "diagonale",
    numero: "02",
    nom: "Diagonale des Fous",
    sousTitre: "Le marathon des cirques, la traversée d'une île de feu.",
    tagline: "La Diagonale traverse La Réunion du sud au nord. Forêts primaires, cirques volcaniques, laves.",
    region: "La Réunion · Océan Indien",
    lieu: "Saint-Pierre → Saint-Denis",
    date: "15-19 oct",
    dateISO: "2026-10-16",
    distance: 165,
    dplus: 10210,
    dminus: 9890,
    cutoff: "67:00",
    itra: 6,
    plateau: null,
    finishRate: 55,
    ravitos: 14,
    version: "V3",
    edition: "2026",
    tags: ["Ultra", "Alpes", "Automne"],
    cardColor: "#C85C2A",
    cardTextColor: "#FFFFFF",
    record: { time: "23:17:00", holder: "François D'Haene", year: 2016 },
    profile: [[0,0],[15,800],[30,2200],[45,1600],[60,2400],[75,1200],[90,2600],[105,1800],[120,900],[135,1500],[150,800],[165,100]],
    overview: "165 km, 10 210 m D+. La traversée de La Réunion du sud au nord. Forêts primaires, cirques volcaniques, passages de rivières. Chaleur tropicale à basse altitude, froid en altitude.",
    segments: [
      { label: "Saint-Pierre → Cilaos", distKm: 41, dplus: 2800, dminus: 800, note: "Départ nocturne. Chaleur tropicale. S'hydrater dès le départ.", isCritical: false },
      { label: "Cilaos → La Plaine des Cafres", distKm: 48, dplus: 3200, dminus: 2800, note: "Le cœur technique. Sentiers glissants, passages de ravines.", isCritical: true },
      { label: "La Plaine des Cafres → Salazie", distKm: 38, dplus: 2100, dminus: 2900, note: "Descente vers Salazie. Genoux et cuisses. Bâtons obligatoires.", isCritical: true },
      { label: "Salazie → Saint-Denis", distKm: 38, dplus: 2110, dminus: 3390, note: "Finale. La descente finale est brutale. Protéger les genoux.", isCritical: false },
    ],
    insights: [
      { numero: "01", titre: "Hydratation tropicale", texte: "En zone basse, la chaleur est intense même de nuit. 800ml/h minimum à basse altitude. Sodium dès le début.", votes: 8, badge: "NUTRI" },
      { numero: "02", titre: "Bâtons obligatoires", texte: "La descente vers Salazie détruit les quadriceps. Sans bâtons dans les ravines, c'est une erreur fatale.", votes: 12, badge: "TIP" },
    ],
    contributions: [],
  },
  {
    id: "saintelyon",
    numero: "03",
    nom: "SaintéLyon",
    sousTitre: "Les classiques françaises, vues sous l'angle stratégie de course.",
    tagline: "72 km de nuit, Lyon à Saint-Étienne. La course des Monts du Lyonnais.",
    region: "Rhône-Alpes",
    lieu: "Lyon → Saint-Étienne",
    date: "6 déc",
    dateISO: "2026-12-06",
    distance: 81,
    dplus: 2100,
    dminus: 2150,
    cutoff: "24:00",
    itra: 4,
    plateau: null,
    finishRate: 78,
    ravitos: 8,
    version: "V5",
    edition: "2026",
    tags: ["Long Trail", "Hiver", "Nuit"],
    cardColor: "#1A1510",
    cardTextColor: "#FFFFFF",
    record: { time: "5:38:00", holder: "Sylvain Cachard", year: 2019 },
    profile: [[0,170],[10,650],[20,900],[30,750],[40,1050],[50,850],[60,980],[70,750],[81,400]],
    overview: "72 km de nuit, Lyon à Saint-Étienne. Course hivernale emblématique, temps froid garanti. Terrain vallonné des Monts du Lyonnais.",
    segments: [
      { label: "Lyon → Mornant", distKm: 28, dplus: 700, dminus: 200, note: "Départ nocturne depuis Lyon. Gestion du froid et de l'éclairage.", isCritical: false },
      { label: "Mornant → Saint-Étienne", distKm: 53, dplus: 1400, dminus: 1950, note: "La seconde moitié est plus technique. Attention aux passages boueux en hiver.", isCritical: true },
    ],
    insights: [
      { numero: "01", titre: "Course de nuit entière", texte: "Piles de rechange, gants, bonnet. La température descend à -5°C certaines années.", votes: 9, badge: "TIP" },
    ],
    contributions: [],
  },
  {
    id: "ecotrail",
    numero: "04",
    nom: "Ecotrail Paris",
    sousTitre: "Un trail urbain qui ne ment pas — de Saint-Quentin-en-Yvelines à Paris.",
    tagline: "Quarante-cinq kilomètres jusqu'à la Dame de Fer.",
    region: "Île-de-France",
    lieu: "Saint-Quentin-en-Yvelines → Paris",
    date: "13 mars",
    dateISO: "2027-03-13",
    distance: 45,
    dplus: 830,
    dminus: 820,
    cutoff: "8:00",
    itra: 3,
    plateau: 4200,
    finishRate: 91,
    ravitos: 4,
    version: "V6",
    edition: "2027",
    tags: ["Trail", "Printemps", "Urbain"],
    cardColor: "#1A1510",
    cardTextColor: "#FFFFFF",
    record: { time: "3:18:24", holder: "Antoine Lallemand", year: 2025 },
    profile: [[0,140],[5,280],[10,350],[15,320],[20,250],[25,300],[30,240],[35,200],[40,180],[45,60]],
    overview: "45 km de Saint-Quentin-en-Yvelines à la Tour Eiffel. Forêt domaniale de Meudon, parc de Saint-Cloud, bois de Boulogne. Trail accessible, finition iconique.",
    segments: [
      { label: "Saint-Quentin → Meudon", distKm: 20, dplus: 420, dminus: 200, note: "Forêt domaniale. Sentiers larges, bon terrain.", isCritical: false },
      { label: "Meudon → Tour Eiffel", distKm: 25, dplus: 410, dminus: 620, note: "Parc Saint-Cloud, Boulogne. Descente finale vers Paris.", isCritical: false },
    ],
    insights: [
      { numero: "01", titre: "Finition unique", texte: "La descente finale vers le Trocadéro est émouvante. Gérer son énergie pour la savourer.", votes: 15, badge: "TIP" },
    ],
    contributions: [],
  },
];

export const FEATURED_ID = "ecotrail";
